export type ISlugify = ReturnType<typeof slugifyFilter>;

/* @ngInject */
export function slugifyFilter() {
  return function (value) {
    if (!value) {
      return value;
    }

    const slug = value
      .toString()
      .toLowerCase()
      .replace(/[\s\W-]+/g, '-')
      .replace(/^-+|-+$/g, ''); // Replace spaces, non-word characters and dashes with a single dash (-)
    return slug || '-'; // if translate get empty string it doesn't use default value
  };
}
